import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEn from '../locales/en.json';
import translationFr from '../locales/fr.json';

export const SupportedLanguages = ['fr', 'en'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: 'translation',
    detection: {
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    },
    fallbackLng: SupportedLanguages[0],
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    resources: {
      en: {
        translation: translationEn,
      },
      fr: {
        translation: translationFr,
      },
    },
    supportedLngs: SupportedLanguages,
  });
/*
  .init({

    resources,
    supportedLngs: supportedLanguages,
  })*/

export default i18n;
